import styled from 'styled-components';

import { colors, LayoutColors } from '@src/core/theme';
import { device } from '@src/common/breakpoints';
import { BodyLargeBold, BodyLargeMedium, BodyRegularSemiBold } from '@src/fonts/typography/Typography';

import { baseButton } from '../shared';

export const HeaderTitle = styled.h1`
  border-bottom: none !important;
  padding-bottom: 0 !important;
  margin-bottom: 16px !important;
`;

export const Button = styled.button`
  ${baseButton};

  color: ${LayoutColors.whiteLight};
  background: ${LayoutColors.justBlue};
  white-space: nowrap;
`;

export const ReservationWrapper = styled.article`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const FooterInfo = styled.footer`
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: center;
  justify-content: center;
  margin-top: 16px;
  gap: 16px;

  p {
    ${BodyLargeMedium};
    color: ${LayoutColors.blackMain};
  }

  ${device.smallTablet} {
    margin-top: 24px;
  }
`;

export const GoBackButton = styled.button`
  cursor: pointer;
  background-color: transparent;
  border: none;

  ${BodyRegularSemiBold};
  color: ${LayoutColors.blackMain};

  ${device.smallTablet} {
    ${BodyLargeBold};
  }
`;

export const PackageContainer = styled.article`
  display: flex;
  padding: 1rem;
  flex-direction: column;
  align-items: flex-start;
  gap: 1rem;
  align-self: stretch;
  background-color: ${colors.black[200]};
  border-radius: 0.5rem;
  margin-bottom: 1rem;
`;

export const PackageHeader = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  align-self: stretch;
  gap: 0.25rem;
  flex-direction: column;

  ${device.smallTablet} {
    flex-direction: row;
  }
`;

export const PackageTitle = styled.h2`
  ${BodyLargeMedium};
  color: ${LayoutColors.blackMain};

  overflow: hidden;
  text-overflow: ellipsis;
  text-align: left;
`;

export const PackageItemList = styled.section`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  align-self: stretch;
`;
